import type { IconProps } from './types'

export const FlagUsIcon = ({ className }: IconProps) => {
  return (
    <svg viewBox="0 0 64 48" className={className} aria-hidden="true">
      <rect width="64" height="48" rx="8" fill="#fff" />
      <clipPath id="us-flag-clip">
        <rect width="64" height="48" rx="8" />
      </clipPath>
      <g clipPath="url(#us-flag-clip)">
        {/* 13 alternating stripes */}
        {Array.from({ length: 13 }).map((_, i) => (
          <rect
            key={i}
            x="0"
            y={i * (48 / 13)}
            width="64"
            height={48 / 13}
            fill={i % 2 === 0 ? '#B22234' : '#fff'}
          />
        ))}
        {/* Blue canton */}
        <rect x="0" y="0" width="27" height={48 * (7 / 13)} fill="#3C3B6E" />
      </g>
    </svg>
  )
}
